import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'empty-state',
  templateUrl: './empty-state.component.html',
  styleUrls: ['./empty-state.component.css']
})
export class EmptyStateComponent implements OnInit {
  
  title = "Chat indisponível";
  message = "Este ambiente não tem permissão para exibir o chat.";

  constructor() { }

  ngOnInit(): void {
  }

}
